import { BellOutlined } from "@ant-design/icons";
import { Badge, Button, Drawer } from "antd";
import { lazy, Suspense, useEffect, useState } from "react";

import { useDevice } from "@app/shared/lib/DeviceProvider";
import { useDrawer, useSdk } from "@app/shared/lib/hooks";
import { LoadingOverlay } from "@app/shared/ui/LoadingOverlay";
import { useUIAppState } from "@app/shared/ui/UIAppState/UIAppStateProvider";

import { Header } from "../Header";

const UserNotifications = lazy(
  () => import("./components/UserNotifications/UserNotifications"),
);

export const Notifications: React.FC = () => {
  const sdk = useSdk();
  const notificationDrawer = useDrawer();
  const [unreadCount, setUnreadCount] = useState(0);
  const device = useDevice();
  const ui = useUIAppState();

  useEffect(() => {
    (async () => {
      const result = await sdk.api.notification.fetchCount({ read: false });
      if (result.success) setUnreadCount(result.body.count);
    })();
  }, [sdk.api.notification]);

  useEffect(() => {
    const unsub = sdk.hub.user.notification.count.subscribe((x) =>
      setUnreadCount(x),
    );

    return () => unsub();
  }, [sdk.hub.user.notification.count]);

  return (
    <>
      <Header.Item onClick={() => notificationDrawer.open()}>
        <Badge count={unreadCount} overflowCount={99}>
          <Button
            icon={<BellOutlined />}
            type="link"
            shape="circle"
            className="bg-gray-3 secondary-text"
          />
        </Badge>
      </Header.Item>
      <Drawer
        open={notificationDrawer.visible}
        onClose={() => notificationDrawer.close()}
        closeIcon={null}
        title={null}
        width={device.deviceSize === "mobile" ? "100%" : 500}
        destroyOnClose
        className="p-0 m-0 no-header"
      >
        <Suspense fallback={<LoadingOverlay />}>
          <UserNotifications
            onSettings={() => {
              ui.setIsProfileDrawerVisible(true, "notifications");
              notificationDrawer.close();
            }}
            onClose={() => notificationDrawer.close()}
          />
        </Suspense>
      </Drawer>
    </>
  );
};
